import { useQuery } from '@tanstack/react-query'
import { api, ApiHttpError } from '../api/client'
import type { MeResponse } from '../api/types'

export const ME_QUERY_KEY = ['me'] as const

/**
 * Resolves the signed-in admin. Returns `data.user` + `data.socket_token`
 * or `undefined`. On 401, returns `data` undefined and `error` is an
 * ApiHttpError — route guards detect this and redirect to /sign-in.
 */
export function useCurrentUser() {
  return useQuery<MeResponse, ApiHttpError>({
    queryKey: ME_QUERY_KEY,
    queryFn: api.getMe,
    retry: (failureCount, error) => {
      // Don't retry 401 — the session is gone, no amount of retries fixes that.
      if (error instanceof ApiHttpError && error.status === 401) return false
      return failureCount < 2
    },
    staleTime: 5 * 60 * 1000, // 5 min — user identity rarely changes mid-session
  })
}
